
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import StbReplacement from "../components/stbreplacement";
import Footer from "../components/footer";

function StbReplacementPage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <Sidebar /> 
      <StbReplacement /> 
    </div>
    <Footer /> 
  </div>
  // <Login/>
  );
}
export default StbReplacementPage;
